import { useLogout } from '@/js/libs/use-auth';

import useLogoutCallback from './useLogoutCallback';

const useAppLogout = () => {
  const logoutCallback = useLogoutCallback();

  const logout = useLogout({
    onLogout: logoutCallback,
  });

  return logout;
};

export default useAppLogout;
